import Footer from "../components/Footer";
import HeroPages from "../components/HeroPages";

function Contact() {
  return (
    <>
      <section className="contact-page">
        <HeroPages name="Contact" />
        <div className="container">
          <div className="contact-div">
            <div className="contact-div__text">
              <h2>Besoin d’informations supplémentaires ?</h2>
                <p>
                  Notre équipe est là pour répondre à toutes vos questions et vous accompagner
                  dans votre réservation. N’hésitez pas à nous contacter pour obtenir plus de
                  détails ou des conseils personnalisés.
                </p>

              <a href="/">
                <i className="fa-solid fa-phone"></i>&nbsp; 06 64 19 87 59
              </a>
              <a href="/">
                <i className="fa-solid fa-envelope"></i>&nbsp;
                kanorjean.christophe@gmail.com
              </a>
              <a href="/">
                <i className="fa-solid fa-location-dot"></i>&nbsp; Bengaluru,
                Karnatka
              </a>
            </div>
            <div className="contact-div__form">
              <form>
                <label>
                  Nom & Prénom<b>*</b>
                </label>
                <input type="text" placeholder='E.g: "Joe Shmoe"'></input>

                <label>
                  Email <b>*</b>
                </label>
                <input type="email" placeholder="youremail@example.com"></input>

                <label>
                  Dites-nous en plus <b>*</b>
                </label>
                <textarea placeholder="Write Here.."></textarea>

                <button type="submit">
                  <i className="fa-solid fa-envelope-open-text"></i>&nbsp; Envoyez-nous un message
                </button>
              </form>
            </div>
          </div>
        </div>
        <div className="book-banner">
          <div className="book-banner__overlay"></div>
          <div className="container">
            <div className="text-content">
              <h2>Reservez votre véhicule en nous contactant</h2>
            <span>
              <i className="fa-solid fa-phone"></i>
              <h3>06 64 19 87 59</h3>
              </span>
            </div>
          </div>
        </div>
        <Footer />
      </section>
    </>
  );
}

export default Contact;
